import React, { useState } from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import ModalGeneralSuccessfully from 'screens/ModalGeneralSuccessfully';
import ModalGeneralFailed from 'screens/ModalGeneralFailed';
import { RESET_WIFI } from 'graphql/service';
import { useMutation } from '@apollo/client';
import { FailIcon } from 'assets/icons';
import { Container } from './styles';

const ModalRestWifi = ({
  buttonStyle,
  roomBookingId
}) => {

  const [isOpen, setIsOpen] = useState(false)
  const [networkName, setNetworkName] = useState('')
  const [wifiPassword, setWifiPassword] = useState('')
  const [successfullyIsOpen, setSuccessfullyIsOpen] = useState(false)
  const [failedIsOpen, setFailedIsOpen] = useState(false)

  const [resetWiFi, { loading }] = useMutation(RESET_WIFI, {
    onCompleted: (wifiData) => {
      if(wifiData.regenerateRoomBookingWiFiCredentials) {
      setNetworkName(wifiData.regenerateRoomBookingWiFiCredentials.ssid)
      setWifiPassword(wifiData.regenerateRoomBookingWiFiCredentials.password)
      setSuccessfullyIsOpen(true)
      setFailedIsOpen(false)
      setIsOpen(false)
      } else {
        setFailedIsOpen(true)
        setIsOpen(false)
      }
    },
    onError: (error) => {
      setFailedIsOpen(true)
      setIsOpen(false)
    }
  })

  const handleReset = () => {
    if(loading) return
    resetWiFi({
      variables: {
        input: {
          roomBookingId: roomBookingId
        }
      },
    })
  }

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-danger"
        buttonLabel="Reset Wi-Fi"
        buttonStyle={buttonStyle}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            height: 100%;
            .close {
              z-index: 200;
            }   
            .modal-body{
              height: 100%;
              padding: 24px;
            }
          }
          top: 179px;
        `}
      >
        <Container>
          <FailIcon />
          <div className="title">Reset Guest Wifi?</div>
          <div className="text">
            Note: you should only do this if there is a problem, because this will invalidate any previously generated credentials and the guest will have to reauthenticate their devices.
          </div>
          <div className="buttonContainer">
            <Button
              danger
              onClick={() => setIsOpen(false)}
              additionalstyle={`
                width: 79px;
                margin-right: 16px;
              `}
            >
              Cancel
            </Button>
            <Button
              success
              onClick={handleReset}
              data-loading={loading}
              additionalstyle={`
                width: 74px;
              `}
            >
              {loading ? null : "Reset"}
            </Button>
          </div>
        </Container>
      </MainModal>
      <ModalGeneralSuccessfully
        isOpen={successfullyIsOpen}
        setIsOpen={setSuccessfullyIsOpen}
        networkName={networkName}
        wifiPassword={wifiPassword}
        type='reset-wifi'
      />
      <ModalGeneralFailed
        isOpen={failedIsOpen}
        setIsOpen={setFailedIsOpen}
        loading={loading}
        retryFunction={handleReset}
        type='reset-wifi'
      />
    </>
  );
}

export default ModalRestWifi;
